/*!
 Leaflet plugin to show PDF page numer
 (c) 2012-2018 Andxor soluzioni informatiche <http://www.andxor.it/>
*/

import $ from 'jquery';
import { Zoom } from 'leaflet/src/control/Control.Zoom';
import * as DomUtil from 'leaflet/src/dom/DomUtil';
import * as DomEvent from 'leaflet/src/dom/DomEvent';
import * as i18n from 'i18n-setup';
import * as Doc from 'doc';
import state from 'state';

export var Pages = Zoom.extend({

    options: {
        position: 'bottomright'
    },

    onAdd: function (map) {
        function setPage(p) {
            p = p|0; // force to be a number
            if (p < 0) p = 0;
            if (p >= state.pageMax) p = (state.pageMax - 1);
            pageCur.innerHTML = (p + 1);
            if (p != $range.slider('option', 'value'))
                $range.slider('option', 'value', p);
            if (p !== state.page)
                Doc.changePage(p);
        }
        function showPageText(p) {
            pageCur.style.display = 'none';
            pageCur2.value = p;
            if (pageCur2.type == 'number') {
                pageCur2.min = 1;
                pageCur2.max = state.pageMax;
            }
            form.style.display = 'inline-block';
            // wait for field to be rendered (IE needs this)
            setTimeout(function () { pageCur2.focus(); }, 10);
        }
        function onPageText() {
            form.style.display = 'none';
            pageCur.style.display = 'inline';
            setPage(parseInt(pageCur2.value, 10) - 1);
            return false;
        }
        function onlyNumbers() {
            if (nonNumbers.test(pageCur2.value))
                pageCur2.value = pageCur2.value.replace(nonNumbers, '');
        }
        function moveAtEnd() {
            // http://stackoverflow.com/a/1675345/166524
            try {
                var len = this.value.length;
                this.setSelectionRange(len, len);
            } catch (e) {
                this.value = this.value;
            }
        }

        var className = 'leaflet-control-zoom',
            container = DomUtil.create('div', className),
            nonNumbers = /[^0-9]/g;

        this._map = map;

        var div = DomUtil.create('div', 'leaflet-control-pages-number', container);
        var pages = DomUtil.create('span', null, div);
        var pageStr = i18n.span('page');
        pages.appendChild(pageStr);
        pages.appendChild(document.createTextNode(' '));
        var pageCur = DomUtil.create('span', null, pages);
        pageCur.innerHTML = (state.page + 1);
        var form = DomUtil.create('form', null, pages);
        var pageCur2 = DomUtil.create('input', null, form);
        try { pageCur2.setAttribute('type', 'number'); } catch (e) { /* defaults to 'text' */ }
        pageCur2.onkeyup = onlyNumbers;
        pageCur2.onfocus = moveAtEnd;
        pageCur2.style.width = '3em';
        pageCur2.showWithPage = showPageText; // to call this from the main code
        form.style.display = 'none';
        form.onsubmit = onPageText;
        pageCur2.onblur = onPageText;
        pages.appendChild(document.createTextNode('/'));
        var pageMax2 = DomUtil.create('span', null, pages);
        pageMax2.innerHTML = state.pageMax;
        var range = DomUtil.create('div', null, container),
            $range = $(range);
        $range.slider({
            min: 0,
            max: 0,
            value: 0,
            range: 'min',
            slide: function (event, ui) { pageCur.innerHTML = (ui.value + 1); },
            change: function (event, ui) { setPage(ui.value); }
        });
        DomEvent.on(pages, 'click', function () { showPageText(state.page + 1); });
        DomEvent.on(container, 'click', DomEvent.stopPropagation);
        DomEvent.on(container, 'touchstart', DomEvent.stopPropagation);
        DomEvent.on(container, 'touchend', DomEvent.stopPropagation);
        DomEvent.on(container, 'touchmove', DomEvent.stopPropagation);
        DomEvent.on(container, 'mousedown', DomEvent.stopPropagation);
        DomEvent.on(container, 'dblclick', DomEvent.stopPropagation);
        this._range = $range;
        this._pageCur = pageCur;
        this._pageMax = pageMax2;
        map.on('layeradd', this._pageChange, this);
        return container;
    },

    _pageChange: function () {
        this._pageCur.innerHTML = (state.page + 1);
        this._pageMax.innerHTML = state.pageMax|0;
        if (state.pageMax < 2)
            this._range.hide();
        else {
            this._range.slider('option', 'max', state.pageMax - 1);
            this._range.slider('option', 'value', state.page|0);
            this._range.show();
        }
    }

});
